import React, {useEffect} from "react";
import {observer} from "mobx-react";
import {Box, Button, useMediaQuery} from "@mui/material";
import {media} from "assets/css/media";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {IPoolModalController} from "views/components/player_pool/pool_modal/pool_modal.controller";
import {getOpenState} from "data/utils/helper";
import {ReactComponent as CloseIcon} from "assets/img/icon/close-white.svg";
import styled from "@emotion/styled";
import {PlayerPool} from "views/components/player_pool/pool/player_pool.component";

const MobileMenuWrapper = styled(Box)`
	position: fixed;
	width: 100%;
	overflow: auto;
	top: 0;
	bottom: 0;
	left: 0;
	background: radial-gradient(63.46% 44.82% at 50% 50%, rgba(22, 39, 68, 0.99) 0%, #061a3b 100%);
	z-index: 999;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	transition: all ease 0.5s;
	background-size: cover;

	&.open {
		transform: translateX(0);
	}

	&.closed {
		transform: translateX(-100%);
	}

	form {
		width: 100%;
		//max-width: 320px;
		margin: 0 auto;
		color: #fff;

		&.personal_data {
			.row {
				flex: 1 1 48%;
				max-width: 48%;

				@media (max-width: ${media.mobile}) {
					flex: 1 1 100%;
					max-width: 100%;
				}
			}
		}

		h2 {
			font-family: "GothamCond", sans-serif;
			font-style: normal;
			font-weight: 700;
			font-size: 32px;
			line-height: 104%;
			text-align: center;
			letter-spacing: -0.02em;
			text-transform: uppercase;
		}

		h6 {
			font-family: "Gotham", sans-serif;
			font-style: normal;
			font-weight: 350;
			font-size: 16px;
			line-height: 130%;
			text-align: center;
		}

		.MuiInputBase-input {
			color: #fff !important;

			&:-webkit-autofill {
				color: #fff !important;
				-webkit-text-fill-color: #fff;
			}
		}

		.MuiTextField-root,
		.MuiSelect-select {
			background: rgba(255, 255, 255, 0.09);
			border-radius: 4px 4px 0 0;
			color: #fff;
		}

		.MuiSelect-select {
			color: #fff;
		}

		.MuiInputBase-formControl {
			color: #fff;

			&:after {
				//border-color: #c81414;
				border-color: #f9d749;
			}

			svg {
				fill: #fff;

				path {
					fill: #fff;
				}
			}
		}

		.MuiInputLabel-formControl {
			color: #a3a3a3;
		}

		.MuiSwitch-track {
			background-color: #616d82;
		}

		.Mui-checked + .MuiSwitch-track {
			background-color: #4c1429;
		}

		.Mui-checked {
			.MuiSwitch-thumb {
				background-color: #c81414;
			}
		}
	}
`;
const MenuHeader = styled(Box)`
	position: relative;
	min-height: 40px;
	width: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 10px;
	border-bottom: 1px solid #333333;
	padding: 5px 0 15px;
	box-sizing: border-box;
	background: var(--thirdColor);

	@media (max-width: ${media.mobile}) {
		padding: 5px 0 0;
		position: sticky;
		top: 0;
		z-index: 9;
	}

	button {
		width: 40px;
		height: 40px;
		min-width: 40px;
		position: absolute;
		top: 50%;
		right: 15px;
		transform: translateY(-50%);

		svg {
			width: 20px;
			height: 20px;
		}
	}
`;

export const PlayerPoolModal: React.FC = observer(() => {
	const {isOpenModal, isCurrentLineupFull, closePoolModal} =
		useViewController<IPoolModalController>(Bindings.PoolModalController);
	const isMobile = useMediaQuery(`(max-width: ${media.mobile})`);

	useEffect(() => {
		if (isMobile && isCurrentLineupFull) {
			closePoolModal();
		}
	}, [isMobile, isCurrentLineupFull, closePoolModal]);

	return isMobile ? (
		<MobileMenuWrapper className={getOpenState(isOpenModal)}>
			<MenuHeader>
				<Button onClick={closePoolModal}>
					<CloseIcon />
				</Button>
				{/*<LogoContainer size={"sm"} style={{margin: "0 auto", color: "#fff"}}>*/}
				{/*	<GameLogo width="121px" />*/}
				{/*</LogoContainer>*/}
			</MenuHeader>

			<PlayerPool />
		</MobileMenuWrapper>
	) : null;
});
